import type { myFetchOptions } from './request';
import type { RuntimeConfig } from "nuxt/schema";

export const normalizeAvatarUrl = (value: string | undefined, config: RuntimeConfig) => {
    if (!value) return "";
    if (value.startsWith("http://") || value.startsWith("https://") || value.startsWith("data:")) {
        const separator = value.includes("?") ? "&" : "?";
        return `${value}${separator}width=120&format=webp`;
    }
    return `${config.public.ossPrefix}${value}?width=120&format=webp`;
}
export const api_UserLogin = (opt: myFetchOptions) => {
    return useHttpFetch('/api/User/Login', opt)
}
export const api_UserLoginOut = (opt: myFetchOptions) => {
    return useHttpFetch('/api/User/LoginOut', opt)
}
export const $api_UserLoginOut = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/LoginOut', opt)
}
export const api_UserRegister = (opt: myFetchOptions) => {
    return useHttpFetch('/api/User/Register', opt)
}

export const $api_UserGetEmailCheckCode = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/GetEmailCheckCode', opt)
}
export const api_GetCurrentUser = (opt: myFetchOptions) => {
    return useHttpFetch('/api/User/GetCurrentUser', opt)
}
export const $api_User_ModifyInfo = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/ModifyInfo', opt)
}

export const $api_User_ModifyPwd = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/ModifyPwd', opt)
}

export const $ModifyPwdByCode = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/ModifyPwdByCode', opt)
}

export const $api_User_GetUserSubcribes = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/GetUserSubcribes', opt)
}

export const $api_User_GetUserFans = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/GetUserFans', opt)
}


export const $api_User_GetMyCounponsByPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/GetMyCounponsByPage', opt)
}

export const api_User_GetMyInviterInfo = (opt: myFetchOptions) => {
    return useHttpFetch('/api/User/GetMyInviterInfo', opt)
}


export const $api_User_GetMySubUsersByPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/User/GetMySubUsersByPage', opt)
}
